/*eslint-disable*/
import api from '../'

class AnagramsApi {
  // get: /anagrams/groups
  static getGroups (locale) {
    return api.axios.get('/anagrams/groups', {
      params: {
        locale
      }
    }).then(response => response.data.groups);
  }

  static getWords (params) {
    return api.axios.get('/anagrams/words', {
      params
    }).then(response => response.data);
  }
}

export default AnagramsApi;
